import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { totalmem, type } from 'os';
import { element } from 'protractor';
import { AlertDialogComponent } from 'src/app/alert-dialog/alert-dialog.component';
import { serverMessage } from 'src/app/popUpMessages/serverMessage';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { MenuService } from 'src/app/services/menu.service';
import { SharedServiceService } from 'src/app/services/shared-service.service';
import { TcDirectcostserviceService } from 'src/app/services/tc-directcostservice.service';
import { CommentboxComponent } from 'src/app/commentbox/commentbox.component';
import { EnumModuleId } from 'src/app/enum/EnumModuleId';
import { UnSavedChangesServiceService } from 'src/app/services/un-saved-changes-service.service';
import { DialogComponent } from 'src/app/dialog/dialog.component';
import { messages } from 'src/app/popUpMessages/messages';

let countryCode;
@Component({
  selector: 'app-tc-directcosts',
  templateUrl: './tc-directcosts.component.html',
  styleUrls: ['./tc-directcosts.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class TcDirectcostsComponent implements OnInit, OnDestroy {
  @ViewChild('commentBox') commentBox: CommentboxComponent;
  hasCommentUnsavedChanges: boolean = false;
  public showGrid = false;
  public projectId: any;
  public hasUnsavedChanges: boolean = false;
  public submitted: boolean = false;
  refTitle: string = "";
  tarTitle: string = "";
  optATitle: string = "";
  optBTitle: string = "";
  optCTitle: string = "";
  domLayout: string;
  refdomLayout: string;
  OptADomLayout: string;
  OptBDomLayout: string;
  OptCDomLayout: string;
  refPinnedBottomData: any;
  tarPinnedBottomData: any;
  optAPinnedBottomData: any;
  optBPinnedBottomData: any;
  optCPinnedBottomData: any;
  rowClassRulesRef: any;
  rowClassRulesTar: any;
  rowClassRulesOptA: any;
  rowClassRulesOptB: any;
  rowClassRulesOptC: any;
  refTotalDirectCosts: any;
  tarTotalDirectCosts: any;
  optATotalDirectCosts: any;
  optBTotalDirectCosts: any;
  optCTotalDirectCosts: any;
  totalDirectCosts = 0;
  configSub: any;
  headerHeight: number;
  rowHeight: number;
  unsavedSub: any;

  constructor(
    private tcDirectCostService: TcDirectcostserviceService,
    private localStorageService: LocalStorageService,
    private sharedService: SharedServiceService,
    private menuService: MenuService,
    private router: Router,
    public dialog: MatDialog,
    private unSavedChangeService: UnSavedChangesServiceService
  ) { }
  gridData: any[];
  tarGridData: any;
  tarGridApi: any;
  tarDefaultColDef: any;
  tarColumnDefs: any;

  refColumnDefs: any;
  refDefaultColDef: any;
  refGridApi: any;
  refGridData: any[];


  optAColumnDefs: any;
  optADefaultColDef: any;
  optAGridData: any[];
  optAGridApi: any;

  optBGridData: any[];
  optBColumnDefs: any;
  optBDefaultColDef: any;
  optBGridApi: any;

  optCGridData: any[];
  optCColumnDefs: any;
  optCDefaultColDef: any;
  optCGridApi: any;

  configurationId: any;
  optAVisible: boolean = false;
  optBVisible: boolean = false;
  optCVisible: boolean = false;
  directCostData: any;
  objData: { projectId: any; moduleId: any; configurationId: any; };
  moduleId: number = 12;


  ngOnInit(): void {
    this.projectId = this.localStorageService.get("projectId");
    this.sharedService.getProjectIdAndTitle();

    countryCode = this.localStorageService.get('countryCode');

    this.unsavedSub = this.unSavedChangeService.checkRequest$.subscribe(() => {
      if (this.hasUnsavedChanges || this.hasCommentUnsavedChanges) {
        const unSavedDialog = this.dialog.open(DialogComponent, { data: { message: messages.UnsavedChanges, okBtn: "Yes", cancelBtn: "No" } })
        unSavedDialog.afterClosed().subscribe(async result => {
          if (result === true) {
            this.unSavedChangeService.respondCheck(true);
            // await this.submit();
            // const submitResult = await this.submit();
            // if (submitResult !== false) {
            //   this.unSavedChangeService.respondCheck(true); // Proceed
            // }
            // else {
            //   this.unSavedChangeService.respondCheck(false); // Proceed (discard)
            // }
          } else {
            this.unSavedChangeService.respondCheck(false); // Proceed (discard)
          }
        });
      }
      else {
        this.unSavedChangeService.respondCheck(true);
        // return;
      }
    });

    this.loadData();
    // this.loadRefGridStructure();
    // this.loadTarGridStructure();
    // this.loadOptAGridStructure();
    // this.loadOptBGridStructure();
    // this.loadOptCGridStructure();
  }
  loadData() {
    this.showGrid = false;
    this.configSub = this.sharedService.configurationId.subscribe(d => {
      this.showGrid = false;

      this.configurationId = d;
      this.objData = {
        projectId: this.projectId,
        moduleId: Number(EnumModuleId.DirectCostTargetCost),
        configurationId: this.configurationId
      }
      // Pass objData to commentbox component
      if (this.commentBox) {
        this.commentBox.updateCommentData(this.objData);
      }
      this.optAVisible = false;
      this.optBVisible = false;
      this.optCVisible = false;

      if (this.configurationId != null) {
        this.tcDirectCostService.getDirectcostsData(this.configurationId).subscribe((data: any) => {
          this.showGrid = true;
          if (data) {
            let errorMsgeFromBack = data.Message;
            if (data.StatusCode == 200) {
              this.directCostData = data;
              let refGridData = this.directCostData.Data.ReferenceScenario;
              let tarGridData = this.directCostData.Data.TargetScenario;
              let optAGridData = this.directCostData.Data.OptionA;
              let optBGridData = this.directCostData.Data.OptionB;
              let optCGridData = this.directCostData.Data.OptionC;
              this.gridData = this.sortAndAddSummaryRow(refGridData);
              this.tarGridData = this.mergeData(tarGridData);

              this.tarGridData.forEach((element, index) => {
                let refRow = this.gridData.find(x => x.Type === element.TargetData.Type && x.Assembly === element.TargetData.Assembly);
                this.tarGridData[index]["RefCost"] = refRow.TotalCosts;
              })

              console.log(this.gridData);

              if (optAGridData.length > 0) {
                this.optAVisible = true;
                this.optAGridData = this.mergeData(this.directCostData.Data.OptionA);
                this.optAGridData.forEach((element, index) => {
                  let refRow = this.gridData.find(x => x.Type === element.TargetData.Type && x.Assembly === element.TargetData.Assembly);
                  this.optAGridData[index]["RefCost"] = refRow.TotalCosts;
                })
              }

              if (optBGridData.length > 0) {
                this.optBVisible = true;
                this.optBGridData = this.mergeData(this.directCostData.Data.OptionB);
                this.optBGridData.forEach((element, index) => {
                  let refRow = this.gridData.find(x => x.Type === element.TargetData.Type && x.Assembly === element.TargetData.Assembly);
                  this.optBGridData[index]["RefCost"] = refRow.TotalCosts;
                })
              }


              if (optCGridData.length > 0) {
                this.optCVisible = true;
                this.optCGridData = this.mergeData(this.directCostData.Data.OptionC);
                this.optCGridData.forEach((element, index) => {
                  let refRow = this.gridData.find(x => x.Type === element.TargetData.Type && x.Assembly === element.TargetData.Assembly);
                  this.optCGridData[index]["RefCost"] = refRow.TotalCosts;
                })
              }


              this.loadRefGridStructure();
              this.loadTarGridStructure();
              this.loadOptAGridStructure();
              this.loadOptBGridStructure();
              this.loadOptCGridStructure();

              // this.refTitle = refGridData?.ScenarioTitle ?? "";
              // console.log(this.refTitle)
              // this.tarTitle = tarGridData?.ScenarioTitle ?? "";
              // console.log(this.refTitle)
              // this.optATitle = optAGridData?.ScenarioTitle ?? "";
              // console.log(this.refTitle)
              // this.optBTitle = optBGridData?.ScenarioTitle ?? "";
              // console.log(this.refTitle)
              // this.optCTitle = optCGridData?.ScenarioTitle ?? "";
              // console.log(this.refTitle)
            }
            else {
              //Show errorCode and errorMessage in the UI
              let errorContainer = [
                { [serverMessage.serverErrorMessage]: serverMessage.serverErrorHeader },
                { [serverMessage.message + errorMsgeFromBack]: serverMessage.serverErrorHeader }
              ]
              this.openAlertDialog(errorContainer);
            }
          }
        });
      }
    });
  }

  mergeData(tarGridData) {
    let targetData = this.sortAndAddSummaryRow(tarGridData.filter(data => data.TypeOfCost === "Target"));
    let forecastData = this.sortAndAddSummaryRow(tarGridData.filter(data => data.TypeOfCost === "Forecast"));
    let actualsData = this.sortAndAddSummaryRow(tarGridData.filter(data => data.TypeOfCost === "Actuals"));

    return targetData.map((item, index) => ({
      TargetData: item,
      ForecastData: forecastData[index],
      ActualsData: actualsData[index]
    }))
  }

  sortAndAddSummaryRow(items) {
    if (items.length != 0 && items != undefined) {
      const sortOrder: { [key: string]: number } = {
        "EQ TC": 1,
        "SCM TC": 2,
        "LC TC": 3,
        "CS TC": 4
      };
      let sortedData = items.sort((a, b) => {
        const typeComparison = sortOrder[a.Type] - sortOrder[b.Type];
        if (typeComparison !== 0) {
          return typeComparison;
        }
        // If Type is the same, compare by Assembly (alphabetical order)
        return a.Assembly.localeCompare(b.Assembly);
      })

      let finalData = [];
      // let currentType = "";
      // let typeTotal = 0;
      let standardProductCostRowAdded = false;
      let totalProductCostRowAdded = false;
      let directserviceCostCostRowAdded = false;
      let EQRows = sortedData.filter(x => x.Type === "EQ TC");
      if (EQRows.length != 0) {
        let EQTotal = 0;
        EQRows.forEach((element) => {
          EQTotal += element.TotalCosts;
        });
        finalData.push(...EQRows);
        finalData.push({
          Type: "Standard Product Costs",
          TotalCosts: EQTotal
        });
        standardProductCostRowAdded = true;
      }
      let SCMLCRows = sortedData.filter(x => x.Type === "SCM TC" || x.Type === "LC TC");
      if (SCMLCRows.length != 0) {
        let SCMLCTotal = 0;
        SCMLCRows.forEach((element) => {
          SCMLCTotal += element.TotalCosts;
        });
        finalData.push(...SCMLCRows);
        if (standardProductCostRowAdded == true) {
          let eqtotal = finalData.find(x => x.Type === "Standard Product Costs").TotalCosts;
          finalData.push({
            Type: "Total Product Costs",
            TotalCosts: SCMLCTotal + eqtotal
          });
        } else {
          finalData.push({
            Type: "Total Product Costs",
            TotalCosts: SCMLCTotal
          });
        }
        totalProductCostRowAdded = true;
      }

      let CSRows = sortedData.filter(x => x.Type === "CS TC");
      if (CSRows.length != 0) {
        let CSTotal = 0;
        CSRows.forEach((element) => {
          CSTotal += element.TotalCosts;
        });
        finalData.push(...CSRows);
        finalData.push({
          Type: "Direct Service Costs",
          TotalCosts: CSTotal
        });
        directserviceCostCostRowAdded = true;
      }
      // sortedData.forEach((element, index) => {
      //   if (element.Type !== currentType) {
      //     if (element.Type !== "LC TC" && (currentType === "LC TC" || currentType === "SCM TC") ) {
      //       totalProductCostRowAdded = true;
      //       finalData.push({
      //         Type: "Total Product Costs",
      //         TotalCosts: typeTotal
      //       });
      //     }
      //     else if (element.Type !== "EQ TC" && currentType === "EQ TC") {
      //       finalData.push({
      //         Type: "Standard Product Costs",
      //         TotalCosts: typeTotal
      //       });
      //     }
      //   }
      //   if (element.Type === "CS TC" && currentType != "CS TC") {
      //     typeTotal = 0;
      //   }
      //   currentType = element.Type;
      //   typeTotal += element.TotalCosts;

      //   finalData.push(element);
      // });


      // finalData.push({
      //   Type: "Direct Service Costs",
      //   TotalCosts: typeTotal
      // });
      return finalData;
    }
    else {
      return [];
    }
  }

  loadRefGridStructure() {
    this.rowClassRulesRef = {
      'colorTotal': function (params) {
        let data = params.data.Type;
        return data === 'Total Direct Costs' || data === 'Total Product Costs' || data === 'Standard Product Costs' || data === 'Direct Service Costs';
      }
    }

    this.refColumnDefs = [
      {
        headerName: "Type",
        field: "Type",
        tooltipField: "Type",
        width: 60,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Type",
        editable: false,
        colSpan: params => {
          return ["Standard Product Costs", "Total Product Costs", "Direct Service Costs"].includes(params.data?.Type) ? 2 : 1;
        }
      },
      {
        headerName: "Assembly Group",
        field: "Assembly",
        tooltipField: "Assembly",
        width: 180,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Assembly Group",
        editable: false
      },
      {
        headerName: "Costs",
        field: "TotalCosts",
        tooltipField: "Costs",
        width: 90,
        // headerClass: "right-border",
        // cellClass: "right-border",
        headerTooltip: "Costs",
        editable: false,
        tooltipValueGetter: CurrencyCellRenderer,
        cellRenderer: CurrencyCellRenderer,
        valueGetter: function (params) {
          if (params.node.data.Type === "Total Direct Costs") {
            let total = 0;
            if (params.api != null) {
              params.api.forEachNode((node) => {
                if (node.data.Type !== "Standard Product Costs" && node.data.Type !== "Total Product Costs" && node.data.Type !== "Direct Service Costs") {
                  total += Number(node.data.TotalCosts);
                }
              });
              params.data.TotalCosts = total;
              return total;
            }
          }
          else {
            return params.data.TotalCosts;
          }
        }
      },
      // {
      //   headerName: "Total Direct Costs",
      //   field: "TotalDirectCosts",
      //   tooltipField: "TotalDirectCosts",
      //   width: 150,
      //   headerClass: "right-border",
      //   cellClass: "right-border",
      //   headerTooltip: "Total Direct Costs",
      //   editable: false,
      //   tooltipValueGetter: CurrencyCellRenderer,
      //   cellRenderer: CurrencyCellRenderer,
      //   valueGetter: function (params) {
      //     if (params.node.data.Type === 'Total Cost') {
      //       //return this.totalDirectCosts;
      //       console.log(params);
      //       let total = 0;
      //       if (params.api != null) {
      //         //conse.log(params.api)
      //         params.api.forEachNode((node) => {
      //           console.log(node.data.TotalDirectCosts)
      //           total += Number(node.data.TotalDirectCosts)
      //           console.log(total)
      //         })
      //         params.data.TotalDirectCosts = total;
      //         return total;
      //       }
      //     } else {
      //       return (params.data.TotalDirectCosts);
      //     }
      //   }
      // },
    ];
    this.refDefaultColDef = {
      suppressMovable: true,
      sortable: false,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      wrapText: true,
    }
    this.rowHeight = 25;
    this.headerHeight = 48;
    //this.gridData = [];
    this.refdomLayout = "autoHeight";
    this.showGrid = true;
  }
  onRefGridReady(params: any) {
    this.refGridApi = params.api;
    this.refGridApi.setHeaderHeight(79);
    this.refPinnedBottomData = createDataRef();
    params.api.setPinnedBottomRowData(this.refPinnedBottomData);
  }
  // onRefCellValueChanged(params) {

  //   let tar = this.tarGridData.find(x => x.Type == params.data.Type)
  //   tar.ReferenceCost = params.data.TotalDirectCosts
  //   this.tarGridApi.redrawRows();

  // }
  // totalRef() {
  //   setTimeout(() => {
  //     let Costs = 0;
  //     //conse.log('HI');
  //     ////conse.log(this.refGridApi.data.TotalDirectCosts);
  //     this.refGridApi.forEachNode(function (node) {
  //       //conse.log('Node data:', node.data);
  //       //conse.log('HI');
  //       Costs = Number(node.data.TotalDirectCosts) + Costs
  //       //conse.log(node.data.TotalDirectCosts);

  //     })
  //     this.refTotalDirectCosts = Costs;
  //     //conse.log(Costs);
  //     return Costs;
  //   }, 1000);

  // }

  onGridRefChanged(params) {
    setTimeout(() => {
      this.refGridApi = params.api;
      this.refGridApi.sizeColumnsToFit();
    }, 1000);

  }

  // this both function will reset the height of row whenever therte is dynamic change in thw data of the cell of the grid;
  onColumnResizedRef(params) {
    params.api.resetRowHeights();
  }

  onColumnVisibleRef(params) {
    params.api.resetRowHeights();
  }
  loadTarGridStructure() {
    this.rowClassRulesTar = {
      'colorTotal': function (params) {
        let data = params.data.TargetData.Type;
        return data === 'Total Direct Costs' || data === 'Total Product Costs' || data === 'Standard Product Costs' || data === 'Direct Service Costs';
      }
    }
    this.tarColumnDefs = [
      {
        headerName: "Type",
        field: "TargetData.Type",
        tooltipField: "Type",
        width: 60,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Type",
        editable: false,
        hide: true
      },
      {
        headerName: "Assembly Group",
        field: "TargetData.Assembly",
        tooltipField: "Assembly",
        width: 180,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Component",
        editable: false,
        hide: true
      },
      {
        headerName: "Target Costs",
        headerTooltip: "Target Costs",
        headerClass: "right-border",
        children: [
          {
            headerName: "Costs",
            field: "TargetData.TotalCosts",
            tooltipField: "Costs",
            width: 150,
            headerClass: "right-border",
            cellClass: "right-border",
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.TargetData.Type === "Total Direct Costs") {
                let total = 0;
                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    if (node.data.TargetData.Type !== "Standard Product Costs" && node.data.TargetData.Type !== "Total Product Costs" && node.data.TargetData.Type !== "Direct Service Costs") {
                      total += Number(node.data.TargetData.TotalCosts);
                    }
                  });
                  params.data.TargetData.TotalCosts = total;
                  return total;
                }
              }
              else {
                return params.data.TargetData.TotalCosts;
              }
            }
          },
          {
            headerName: "Delta to Reference",
            field: "DeltaFCVsRef",
            tooltipField: "Costs",
            width: 150,
            headerClass: "right-border",
            //  cellClass: "right-border",
            headerTooltip: "Material",
            editable: false,
            cellClass: (params) => {
              if (params.value >= 0)
                return "colorTotal positive-num-color-scm right-border"
              else
                return "colorTotal negative-num-color-scm right-border"
            },
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.api != null) {
                if (params.data.TargetData.Type === "Total Direct Costs") {
                  return Number(params.data.TargetData.TotalCosts) - Number(params.context.referenceApi.pinnedRowModel.pinnedBottomRows[0].data.TotalCosts)
                }
                else {
                  return Number(params.data.TargetData.TotalCosts) - Number(params.data.RefCost);
                }
              }
            }
          }
        ]
      },
      {
        headerName: "Forecast",
        headerTooltip: "Forecast",
        headerClass: "right-border",
        children: [
          {
            headerName: "Costs",
            field: "ForecastData.TotalCosts",
            tooltipField: "Costs",
            width: 150,
            headerClass: "right-border",
            cellClass: "right-border",
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.ForecastData.Type === "Total Direct Costs") {
                let total = 0;
                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    if (node.data.ForecastData.Type !== "Standard Product Costs" && node.data.ForecastData.Type !== "Total Product Costs" && node.data.ForecastData.Type !== "Direct Service Costs") {
                      total += Number(node.data.ForecastData.TotalCosts);
                    }
                  });
                  params.data.ForecastData.TotalCosts = total;
                  return total;
                }
              }
              else {
                return params.data.ForecastData.TotalCosts;
              }
            }
          },
          {
            headerName: "Delta to Reference",
            // field: "Cost",
            tooltipField: "Costs",
            width: 150,
            headerClass: "right-border",
            // cellClass: "right-border",
            cellClass: (params) => {
              if (params.value >= 0)
                return "colorTotal positive-num-color-scm right-border"
              else
                return "colorTotal negative-num-color-scm right-border"
            },
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.api != null) {
                if (params.data.TargetData.Type === "Total Direct Costs") {
                  return Number(params.data.ForecastData.TotalCosts) - Number(params.context.referenceApi.pinnedRowModel.pinnedBottomRows[0].data.TotalCosts)
                }
                else {
                  return Number(params.data.ForecastData.TotalCosts) - Number(params.data.RefCost);
                }
              }
            }
          }
        ]
      },
      {
        headerName: "Actuals",
        headerTooltip: "Actuals",
        // headerClass: "right-border",
        children: [
          {
            headerName: "Costs",
            field: "ActualsData.TotalCosts",
            tooltipField: "Costs",
            width: 150,
            headerClass: "right-border",
            cellClass: "right-border",
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.ActualsData.Type === "Total Direct Costs") {
                let total = 0;
                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    if (node.data.ActualsData.Type !== "Standard Product Costs" && node.data.ActualsData.Type !== "Total Product Costs" && node.data.ActualsData.Type !== "Direct Service Costs") {
                      total += Number(node.data.ActualsData.TotalCosts);
                    }
                  });
                  params.data.ActualsData.TotalCosts = total;
                  return total;
                }
              }
              else {
                return params.data.ActualsData.TotalCosts;
              }
            }
          },
          {
            headerName: "Delta to Reference",
            field: "Cost",
            tooltipField: "Costs",
            width: 150,
            // headerClass: "right-border",
            // cellClass: "right-border",
            cellClass: (params) => {
              if (params.value >= 0)
                return "colorTotal positive-num-color-scm"
              else
                return "colorTotal negative-num-color-scm"
            },
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.api != null) {
                if (params.data.ActualsData.Type === "Total Direct Costs") {
                  return Number(params.data.ActualsData.TotalCosts) - Number(params.context.referenceApi.pinnedRowModel.pinnedBottomRows[0].data.TotalCosts)
                }
                else {
                  return Number(params.data.ActualsData.TotalCosts) - Number(params.data.RefCost);
                }
              }
            }
          }
        ]
      }
      // {
      //   headerName: "Type",
      //   tooltipField: "Type",
      //   width: 60,
      //   headerClass: "right-border",
      //   cellClass: "right-border",
      //   headerTooltip: "Type",
      //   editable: false
      // },

      // {
      //   headerName: "Total Direct Costs",
      //   field: "TotalDirectCosts",
      //   tooltipField: "Total Direct Costs",
      //   width: 150,
      //   headerClass: "right-border",
      //   cellClass: "right-border",
      //   headerTooltip: "Total Direct Costs",
      //   editable: false,
      //   tooltipValueGetter: CurrencyCellRenderer,
      //   cellRenderer: CurrencyCellRenderer,
      //   valueGetter: function (params) {
      //     if (params.node.data.Type === 'Total Cost') {
      //       //conse.log('HI');
      //       let total = 0;
      //       if (params.api != null) {
      //         //conse.log(params.api)
      //         params.api.forEachNode((node) => {
      //           total += Number(node.data.TotalDirectCosts)
      //           console.log(total)
      //         })
      //         params.data.TotalDirectCosts = total;
      //         return total;
      //       }
      //     }
      //     else if (params.node.data.Type === 'Change to Reference') {
      //       let referenceTotal = 0;
      //       params.api.forEachNode((node) => {
      //         referenceTotal = Number(node.data.referenceTotal)
      //         //console.log(referenceTotal)
      //       })
      //       let targetTotal = 0;
      //       params.api.forEachNode((node) => {
      //         targetTotal += Number(node.data.TotalDirectCosts)
      //         //conse.log(targetTotal)
      //       })
      //       params.node.data.TotalDirectCosts = referenceTotal - targetTotal

      //       //conse.log(params.node.data.TotalDirectCosts);
      //       //params.node.data.DeltaTCVsRef = (params.node.data.DeltaTCVsRef == 0) ? null : params.node.data.DeltaTCVsRef
      //       return params.node.data.TotalDirectCosts;
      //     }
      //     else {
      //       return (params.data.TotalDirectCosts);
      //     }
      //   }
      // },
    ];
    this.tarDefaultColDef = {
      suppressMovable: true,
      sortable: false,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      wrapText: true,
    }
    this.rowHeight = 25;
    this.headerHeight = 48;
    this.domLayout = "autoHeight";
    this.showGrid = true;
  }

  onTarGridReady(params: any) {
    // console.log(this.tarGridData);
    this.tarGridApi = params.api;
    this.tarGridApi.setGroupHeaderHeight(30);
    this.tarPinnedBottomData = createDataTar();
    // console.log(this.tarPinnedBottomData);
    params.api.setPinnedBottomRowData(this.tarPinnedBottomData);
  }
  totalTar() {
    let Costs = 0
    this.tarGridApi.forEachNode(function (node) {
      //conse.log(node.data);
      Costs = Number(node.data.TotalDirectCosts) + Costs
    })
    //conse.log(Costs);
    return Costs;
  }
  changeRefenceTar() {
    let tarChangeRefrence = 0;
    tarChangeRefrence = this.refTotalDirectCosts - this.tarTotalDirectCosts;
    return tarChangeRefrence
  }


  onTarRefChanged(params) {
    setTimeout(() => {
      this.tarGridApi = params.api;
      this.tarGridApi.sizeColumnsToFit();
    }, 1000);

  }
  onGridTarChanged(params) {
    setTimeout(() => {
      this.tarGridApi = params.api;
      this.tarGridApi.sizeColumnsToFit();
    }, 1000);

  }

  // this both function will reset the height of row whenever therte is dynamic change in thw data of the cell of the grid;
  onColumnResizedTar(params) {
    params.api.resetRowHeights();
  }

  onColumnVisibleTar(params) {
    params.api.resetRowHeights();
  }

  loadOptAGridStructure() {
    this.rowClassRulesOptA = {
      'colorTotal': function (params) {
        let data = params.data.TargetData.Type;
        return data === 'Total Direct Costs' || data === 'Total Product Costs' || data === 'Standard Product Costs' || data === 'Direct Service Costs';
      }
    }
    this.optAColumnDefs = [

      {
        headerName: "Type",
        field: "TargetData.Type",
        tooltipField: "Type",
        width: 60,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Type",
        editable: false,
        hide: true
      },
      {
        headerName: "Assembly Group",
        field: "TargetData.Assembly",
        tooltipField: "Assembly",
        width: 180,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Component",
        editable: false,
        hide: true
      },
      {
        headerName: "Target Costs",
        headerTooltip: "Target Costs",
        headerClass: "right-border",
        children: [
          {
            headerName: "Costs",
            field: "TargetData.TotalCosts",
            tooltipField: "Costs",
            width: 150,
            headerClass: "right-border",
            cellClass: "right-border",
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.TargetData.Type === "Total Direct Costs") {
                let total = 0;
                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    if (node.data.TargetData.Type !== "Standard Product Costs" && node.data.TargetData.Type !== "Total Product Costs" && node.data.TargetData.Type !== "Direct Service Costs") {
                      total += Number(node.data.TargetData.TotalCosts);
                    }
                  });
                  params.data.TargetData.TotalCosts = total;
                  return total;
                }
              }
              else {
                return params.data.TargetData.TotalCosts;
              }
            }
          },
          {
            headerName: "Delta to Reference",
            // field: "Cost",
            tooltipField: "Costs",
            width: 150,
            headerClass: "right-border",
            // cellClass: "right-border",
            cellClass: (params) => {
              if (params.value >= 0)
                return "colorTotal positive-num-color-scm right-border"
              else
                return "colorTotal negative-num-color-scm right-border"
            },
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.api != null) {
                if (params.data.TargetData.Type === "Total Direct Costs") {
                  return Number(params.data.TargetData.TotalCosts) - Number(params.context.referenceApi.pinnedRowModel.pinnedBottomRows[0].data.TotalCosts)
                }
                else {
                  return Number(params.data.TargetData.TotalCosts) - Number(params.data.RefCost);
                }
              }
            }
          }
        ]
      },
      {
        headerName: "Forecast",
        headerTooltip: "Forecast",
        headerClass: "right-border",
        children: [
          {
            headerName: "Costs",
            field: "ForecastData.TotalCosts",
            tooltipField: "Costs",
            width: 150,
            headerClass: "right-border",
            cellClass: "right-border",
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.ForecastData.Type === "Total Direct Costs") {
                let total = 0;
                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    if (node.data.ForecastData.Type !== "Standard Product Costs" && node.data.ForecastData.Type !== "Total Product Costs" && node.data.ForecastData.Type !== "Direct Service Costs") {
                      total += Number(node.data.ForecastData.TotalCosts);
                    }
                  });
                  params.data.ForecastData.TotalCosts = total;
                  return total;
                }
              }
              else {
                return params.data.ForecastData.TotalCosts;
              }
            }
          },
          {
            headerName: "Delta to Reference",
            // field: "Cost",
            tooltipField: "Costs",
            width: 150,
            headerClass: "right-border",
            //cellClass: "right-border",
            cellClass: (params) => {
              if (params.value >= 0)
                return "colorTotal positive-num-color-scm right-border"
              else
                return "colorTotal negative-num-color-scm right-border"
            },
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.api != null) {
                if (params.data.TargetData.Type === "Total Direct Costs") {
                  return Number(params.data.ForecastData.TotalCosts) - Number(params.context.referenceApi.pinnedRowModel.pinnedBottomRows[0].data.TotalCosts)
                }
                else {
                  return Number(params.data.ForecastData.TotalCosts) - Number(params.data.RefCost);
                }
              }
            }
          }
        ]
      },
      {
        headerName: "Actuals",
        headerTooltip: "Actuals",
        // headerClass: "right-border",
        children: [
          {
            headerName: "Costs",
            field: "ActualsData.TotalCosts",
            tooltipField: "Costs",
            width: 150,
            headerClass: "right-border",
            cellClass: "right-border",
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.ActualsData.Type === "Total Direct Costs") {
                let total = 0;
                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    if (node.data.ActualsData.Type !== "Standard Product Costs" && node.data.ActualsData.Type !== "Total Product Costs" && node.data.ActualsData.Type !== "Direct Service Costs") {
                      total += Number(node.data.ActualsData.TotalCosts);
                    }
                  });
                  params.data.ActualsData.TotalCosts = total;
                  return total;
                }
              }
              else {
                return params.data.ActualsData.TotalCosts;
              }
            }
          },
          {
            headerName: "Delta to Reference",
            field: "Cost",
            tooltipField: "Costs",
            width: 150,
            // headerClass: "right-border",
            // cellClass: "right-border",
            cellClass: (params) => {
              if (params.value >= 0)
                return "colorTotal positive-num-color-scm"
              else
                return "colorTotal negative-num-color-scm"
            },
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.api != null) {
                if (params.data.ActualsData.Type === "Total Direct Costs") {
                  return Number(params.data.ActualsData.TotalCosts) - Number(params.context.referenceApi.pinnedRowModel.pinnedBottomRows[0].data.TotalCosts)
                }
                else {
                  return Number(params.data.ActualsData.TotalCosts) - Number(params.data.RefCost);
                }
              }
            }
          }
        ]
      }
    ];
    this.optADefaultColDef = {
      suppressMovable: true,
      sortable: false,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      wrapText: true,
    }
    this.rowHeight = 25;
    this.headerHeight = 48;
    this.OptADomLayout = "autoHeight";
    this.showGrid = true;
  }

  onOptAGridReady(params: any) {
    this.optAGridApi = params.api;
    this.optAGridApi.setGroupHeaderHeight(30);
    this.optAPinnedBottomData = createDataOptA();
    console.log(this.optAPinnedBottomData);
    params.api.setPinnedBottomRowData(this.optAPinnedBottomData);
  }
  totalOptA() {
    let costs = 0
    this.optAGridApi.forEachNode(function (node) {
      costs = Number(node.data.TotalDirectCosts) + costs
    })
    this.optATotalDirectCosts = costs;
    return costs;
  }
  changeRefenceOptA() {
    //conse.log(this.optATotalDirectCosts);
    let optAChangeRefrence = 0;
    optAChangeRefrence = this.refTotalDirectCosts - this.optATotalDirectCosts;
    return optAChangeRefrence
  }

  onGridOptACSChanged(params) {
    setTimeout(() => {
      this.optAGridApi = params.api;
      this.optAGridApi.sizeColumnsToFit();
    }, 1000);

  }

  // this both function will reset the height of row whenever therte is dynamic change in thw data of the cell of the grid;
  onColumnResizedOptA(params) {
    params.api.resetRowHeights();
  }

  onColumnVisibleOptA(params) {
    params.api.resetRowHeights();
  }

  loadOptBGridStructure() {
    this.rowClassRulesOptB = {
      'colorTotal': function (params) {
        let data = params.data.TargetData.Type;
        return data === 'Total Direct Costs' || data === 'Total Product Costs' || data === 'Standard Product Costs' || data === 'Direct Service Costs';
      }
    }
    this.optBColumnDefs = [

      {
        headerName: "Type",
        field: "TargetData.Type",
        tooltipField: "Type",
        width: 60,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Type",
        editable: false,
        hide: true
      },
      {
        headerName: "Assembly Group",
        field: "TargetData.Assembly",
        tooltipField: "Assembly",
        width: 180,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Component",
        editable: false,
        hide: true
      },
      {
        headerName: "Target Costs",
        headerTooltip: "Target Costs",
        headerClass: "right-border",
        children: [
          {
            headerName: "Costs",
            field: "TargetData.TotalCosts",
            tooltipField: "Costs",
            width: 150,
            headerClass: "right-border",
            cellClass: "right-border",
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.TargetData.Type === "Total Direct Costs") {
                let total = 0;
                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    if (node.data.TargetData.Type !== "Standard Product Costs" && node.data.TargetData.Type !== "Total Product Costs" && node.data.TargetData.Type !== "Direct Service Costs") {
                      total += Number(node.data.TargetData.TotalCosts);
                    }
                  });
                  params.data.TargetData.TotalCosts = total;
                  return total;
                }
              }
              else {
                return params.data.TargetData.TotalCosts;
              }
            }
          },
          {
            headerName: "Delta to Reference",
            // field: "Cost",
            tooltipField: "Delta to Reference",
            width: 150,
            headerClass: "right-border",
            // cellClass: "right-border",
            cellClass: (params) => {
              if (params.value >= 0)
                return "colorTotal positive-num-color-scm right-border"
              else
                return "colorTotal negative-num-color-scm right-border"
            },
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.api != null) {
                if (params.data.TargetData.Type === "Total Direct Costs") {
                  return Number(params.data.TargetData.TotalCosts) - Number(params.context.referenceApi.pinnedRowModel.pinnedBottomRows[0].data.TotalCosts)
                }
                else {
                  return Number(params.data.TargetData.TotalCosts) - Number(params.data.RefCost);
                }
              }
            }
          }
        ]
      },
      {
        headerName: "Forecast",
        headerTooltip: "Forecast",
        headerClass: "right-border",
        children: [
          {
            headerName: "Costs",
            field: "ForecastData.TotalCosts",
            tooltipField: "Costs",
            width: 150,
            headerClass: "right-border",
            cellClass: "right-border",
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.ForecastData.Type === "Total Direct Costs") {
                let total = 0;
                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    if (node.data.ForecastData.Type !== "Standard Product Costs" && node.data.ForecastData.Type !== "Total Product Costs" && node.data.ForecastData.Type !== "Direct Service Costs") {
                      total += Number(node.data.ForecastData.TotalCosts);
                    }
                  });
                  params.data.ForecastData.TotalCosts = total;
                  return total;
                }
              }
              else {
                return params.data.ForecastData.TotalCosts;
              }
            }
          },
          {
            headerName: "Delta to Reference",
            // field: "Cost",
            tooltipField: "Costs",
            width: 150,
            headerClass: "right-border",
            cellClass: (params) => {
              if (params.value >= 0)
                return "colorTotal positive-num-color-scm right-border"
              else
                return "colorTotal negative-num-color-scm right-border"
            },
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.api != null) {
                if (params.data.TargetData.Type === "Total Direct Costs") {
                  return Number(params.data.ForecastData.TotalCosts) - Number(params.context.referenceApi.pinnedRowModel.pinnedBottomRows[0].data.TotalCosts)
                }
                else {
                  return Number(params.data.ForecastData.TotalCosts) - Number(params.data.RefCost);
                }
              }
            }
          }
        ]
      },
      {
        headerName: "Actuals",
        headerTooltip: "Actuals",
        // headerClass: "right-border",
        children: [
          {
            headerName: "Costs",
            field: "ActualsData.TotalCosts",
            tooltipField: "Costs",
            width: 150,
            headerClass: "right-border",
            cellClass: "right-border",
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.ActualsData.Type === "Total Direct Costs") {
                let total = 0;
                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    if (node.data.ActualsData.Type !== "Standard Product Costs" && node.data.ActualsData.Type !== "Total Product Costs" && node.data.ActualsData.Type !== "Direct Service Costs") {
                      total += Number(node.data.ActualsData.TotalCosts);
                    }
                  });
                  params.data.ActualsData.TotalCosts = total;
                  return total;
                }
              }
              else {
                return params.data.ActualsData.TotalCosts;
              }
            }
          },
          {
            headerName: "Delta to Reference",
            field: "Cost",
            tooltipField: "Costs",
            width: 150,
            // headerClass: "right-border",
            // cellClass: "right-border",
            cellClass: (params) => {
              if (params.value >= 0)
                return "colorTotal positive-num-color-scm"
              else
                return "colorTotal negative-num-color-scm"
            },
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.api != null) {
                if (params.data.ActualsData.Type === "Total Direct Costs") {
                  return Number(params.data.ActualsData.TotalCosts) - Number(params.context.referenceApi.pinnedRowModel.pinnedBottomRows[0].data.TotalCosts)
                }
                else {
                  return Number(params.data.ActualsData.TotalCosts) - Number(params.data.RefCost);
                }
              }
            }
          }
        ]
      }
    ];
    this.optBDefaultColDef = {
      suppressMovable: true,
      sortable: false,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      wrapText: true,
    }
    this.rowHeight = 25;
    this.headerHeight = 48;
    this.OptBDomLayout = "autoHeight";
    this.showGrid = true;
  }

  onOptBGridReady(params: any) {
    this.optBGridApi = params.api;
    this.optBGridApi.setGroupHeaderHeight(30);
    this.optBPinnedBottomData = createDataOptB();
    params.api.setPinnedBottomRowData(this.optBPinnedBottomData);
  }
  totalOptB() {
    let costs = 0
    this.optBGridApi.forEachNode(function (node) {
      costs = Number(node.data.TotalDirectCosts) + costs
    })
    this.optBTotalDirectCosts = costs;
    return this.optBTotalDirectCosts;
  }
  changeRefenceOptB() {
    let optBChangeRefrence = 0;
    optBChangeRefrence = this.refTotalDirectCosts - this.optBTotalDirectCosts;
    return optBChangeRefrence
  }
  onGridOptBCSChanged(params) {
    setTimeout(() => {
      this.optBGridApi = params.api;
      this.optBGridApi.sizeColumnsToFit();
    }, 1000);

  }

  // this both function will reset the height of row whenever therte is dynamic change in thw data of the cell of the grid;
  onColumnResizedOptB(params) {
    params.api.resetRowHeights();
  }

  onColumnVisibleOptB(params) {
    params.api.resetRowHeights();
  }

  loadOptCGridStructure() {
    this.rowClassRulesOptC = {
      'colorTotal': function (params) {
        let data = params.data.TargetData.Type;
        return data === 'Total Direct Costs' || data === 'Total Product Costs' || data === 'Standard Product Costs' || data === 'Direct Service Costs';
      }
    }
    this.optCColumnDefs = [

      {
        headerName: "Type",
        field: "TargetData.Type",
        tooltipField: "Type",
        width: 60,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Type",
        editable: false,
        hide: true
      },
      {
        headerName: "Assembly Group",
        field: "TargetData.Assembly",
        tooltipField: "Assembly",
        width: 180,
        headerClass: "right-border",
        cellClass: "right-border",
        headerTooltip: "Component",
        editable: false,
        hide: true
      },
      {
        headerName: "Target Costs",
        headerTooltip: "Target Costs",
        headerClass: "right-border",
        children: [
          {
            headerName: "Costs",
            field: "TargetData.TotalCosts",
            tooltipField: "Costs",
            width: 150,
            headerClass: "right-border",
            cellClass: "right-border",
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.TargetData.Type === "Total Direct Costs") {
                let total = 0;
                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    if (node.data.TargetData.Type !== "Standard Product Costs" && node.data.TargetData.Type !== "Total Product Costs" && node.data.TargetData.Type !== "Direct Service Costs") {
                      total += Number(node.data.TargetData.TotalCosts);
                    }
                  });
                  params.data.TargetData.TotalCosts = total;
                  return total;
                }
              }
              else {
                return params.data.TargetData.TotalCosts;
              }
            }
          },
          {
            headerName: "Delta to Reference",
            // field: "Cost",
            tooltipField: "Costs",
            width: 150,
            headerClass: "right-border",
            //   cellClass: "right-border",
            cellClass: (params) => {
              if (params.value >= 0)
                return "colorTotal positive-num-color-scm right-border"
              else
                return "colorTotal negative-num-color-scm right-border"
            },
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.api != null) {
                if (params.data.TargetData.Type === "Total Direct Costs") {
                  return Number(params.data.TargetData.TotalCosts) - Number(params.context.referenceApi.pinnedRowModel.pinnedBottomRows[0].data.TotalCosts)
                }
                else {
                  return Number(params.data.TargetData.TotalCosts) - Number(params.data.RefCost);
                }
              }
            }
          }
        ]
      },
      {
        headerName: "Forecast",
        headerTooltip: "Forecast",
        headerClass: "right-border",
        children: [
          {
            headerName: "Costs",
            field: "ForecastData.TotalCosts",
            tooltipField: "Costs",
            width: 150,
            headerClass: "right-border",
            cellClass: "right-border",
            // cellClass: (params) => {
            //   debugger;
            //   if (params.value >= 0)
            //     return "colorTotal positive-num-color-scm right-border"
            //   else
            //     return "colorTotal negative-num-color-scm right-border"
            // },
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.ForecastData.Type === "Total Direct Costs") {
                let total = 0;
                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    if (node.data.ForecastData.Type !== "Standard Product Costs" && node.data.ForecastData.Type !== "Total Product Costs" && node.data.ForecastData.Type !== "Direct Service Costs") {
                      total += Number(node.data.ForecastData.TotalCosts);
                    }
                  });
                  params.data.ForecastData.TotalCosts = total;
                  return total;
                }
              }
              else {
                return params.data.ForecastData.TotalCosts;
              }
            }
          },
          {
            headerName: "Delta to Reference",
            // field: "Cost",
            tooltipField: "Costs",
            width: 150,
            headerClass: "right-border",
            //cellClass: "right-border",
            cellClass: (params) => {

              if (params.value >= 0)
                return "colorTotal positive-num-color-scm right-border"
              else
                return "colorTotal negative-num-color-scm right-border"
            },
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.api != null) {
                if (params.data.TargetData.Type === "Total Direct Costs") {
                  return Number(params.data.ForecastData.TotalCosts) - Number(params.context.referenceApi.pinnedRowModel.pinnedBottomRows[0].data.TotalCosts)
                }
                else {
                  return Number(params.data.ForecastData.TotalCosts) - Number(params.data.RefCost);
                }
              }
            }
          }
        ]
      },
      {
        headerName: "Actuals",
        headerTooltip: "Actuals",
        // headerClass: "right-border",
        children: [
          {
            headerName: "Costs",
            field: "ActualsData.TotalCosts",
            tooltipField: "Costs",
            width: 150,
            headerClass: "right-border",
            cellClass: "right-border",
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.node.data.ActualsData.Type === "Total Direct Costs") {
                let total = 0;
                if (params.api != null) {
                  params.api.forEachNode((node) => {
                    if (node.data.ActualsData.Type !== "Standard Product Costs" && node.data.ActualsData.Type !== "Total Product Costs" && node.data.ActualsData.Type !== "Direct Service Costs") {
                      total += Number(node.data.ActualsData.TotalCosts);
                    }
                  });
                  params.data.ActualsData.TotalCosts = total;
                  return total;
                }
              }
              else {
                return params.data.ActualsData.TotalCosts;
              }
            }
          },
          {
            headerName: "Delta to Reference",
            field: "Cost",
            tooltipField: "Costs",
            width: 150,
            // headerClass: "right-border",
            // cellClass: "right-border",
            cellClass: (params) => {
              if (params.value >= 0)
                return "colorTotal positive-num-color-scm"
              else
                return "colorTotal negative-num-color-scm"
            },
            headerTooltip: "Material",
            editable: false,
            tooltipValueGetter: CurrencyCellRenderer,
            cellRenderer: CurrencyCellRenderer,
            valueGetter: function (params) {
              if (params.api != null) {
                if (params.data.ActualsData.Type === "Total Direct Costs") {
                  return Number(params.data.ActualsData.TotalCosts) - Number(params.context.referenceApi.pinnedRowModel.pinnedBottomRows[0].data.TotalCosts)
                }
                else {
                  return Number(params.data.ActualsData.TotalCosts) - Number(params.data.RefCost);
                }
              }
            }
          }
        ]
      }
    ];
    this.optCDefaultColDef = {
      suppressMovable: true,
      sortable: false,
      // this below two property is used to wrap the text of the responsible field in a cell by increasing th height of the cell;
      wrapText: true,
    }
    this.rowHeight = 25;
    this.headerHeight = 48;
    this.OptCDomLayout = "autoHeight";
    this.showGrid = true;
  }

  onOptCGridReady(params: any) {
    this.optCGridApi = params.api;
    this.optCGridApi.setGroupHeaderHeight(30);
    this.optCPinnedBottomData = createDataOptC();
    params.api.setPinnedBottomRowData(this.optCPinnedBottomData);
  }
  totalOptC() {
    let costs = 0
    this.optCGridApi.forEachNode(function (node) {
      costs = Number(node.data.TotalDirectCosts) + costs
    })
    this.optCTotalDirectCosts = costs;
    return costs;
  }
  changeRefenceOptC() {
    let optCChangeRefrence = 0;
    optCChangeRefrence = this.refTotalDirectCosts - this.optCTotalDirectCosts;
    return optCChangeRefrence
  }

  onGridOptCCSChanged(params) {
    setTimeout(() => {
      this.optCGridApi = params.api;
      this.optCGridApi.sizeColumnsToFit();
    }, 1000);

  }

  // this both function will reset the height of row whenever therte is dynamic change in thw data of the cell of the grid;
  onColumnResizedOptC(params) {
    params.api.resetRowHeights();
  }

  onColumnVisibleOptC(params) {
    params.api.resetRowHeights();
  }
  openAlertDialog(error) {
    this.dialog.open(AlertDialogComponent, { data: error })
  }
  onClickCancel() {
    this.hasUnsavedChanges = false;
    this.router.navigate(["/tc-manageProject"]);
  }

  onClickBack() {
    this.menuService.onClickNextAndBack("back");
  }

  onClickNext() {
    this.menuService.onClickNextAndBack("next");
  }
  submit(event?: any) {
    this.router.navigate(['/tc-manageProject']);
  }
  ngOnDestroy(): void {
    this.configSub.unsubscribe();
  }

  canDeactivate() {
    return this.hasUnsavedChanges;
  }

  // Check if comment has unsaved changes
  canDeactivateComment(): boolean {
    return this.hasCommentUnsavedChanges;
  }

  // Handle comment unsaved changes event from child
  onCommentUnsavedChange(hasChanges: boolean) {
    this.hasCommentUnsavedChanges = hasChanges;
  }

  // Submit comment changes
  async submitComment(): Promise<boolean> {
    if (this.commentBox && this.hasCommentUnsavedChanges) {
      return await this.commentBox.saveCommentIfNeeded();
    }
    return true;
  }
}
// creates row for "Total Direc Costs" for reference
function createDataRef() {
  //conse.log(totalCost);
  let result = [];
  result.push({
    Type: "Total Direct Costs",
    TotalCosts: null
  });
  return result;
};
// creates row for "Total Direc Costs" for target
function createDataTar() {
  let result = [];
  result.push(
    {
      TargetData: {
        Type: "Total Direct Costs",
        TotalCosts: null
      },
      ForecastData: {
        Type: "Total Direct Costs",
        TotalCosts: null
      },
      ActualsData: {
        Type: "Total Direct Costs",
        TotalCosts: null
      }
    });
  // result.push({
  //   Type: "Change to Reference",
  //   TotalDirectCosts: null,
  // });
  return result;
};
// creates row for "Total Direc Costs" for OptionA
function createDataOptA() {
  let result = [];
  result.push(
    {
      TargetData: {
        Type: "Total Direct Costs",
        TotalCosts: null
      },
      ForecastData: {
        Type: "Total Direct Costs",
        TotalCosts: null
      },
      ActualsData: {
        Type: "Total Direct Costs",
        TotalCosts: null
      }
    });
  // result.push({
  //   Type: "Change to Reference",
  //   TotalDirectCosts: null,
  // });
  return result;
};
// creates row for "Total Direc Costs" for OptionB
function createDataOptB() {
  let result = [];
  result.push(
    {
      TargetData: {
        Type: "Total Direct Costs",
        TotalCosts: null
      },
      ForecastData: {
        Type: "Total Direct Costs",
        TotalCosts: null
      },
      ActualsData: {
        Type: "Total Direct Costs",
        TotalCosts: null
      }
    });
  // result.push({
  //   Type: "Change to Reference",
  //   TotalDirectCosts: null
  // });
  return result;
};
// creates row for "Total Direc Costs" for OptionC
function createDataOptC() {
  let result = [];
  result.push(
    {
      TargetData: {
        Type: "Total Direct Costs",
        TotalCosts: null
      },
      ForecastData: {
        Type: "Total Direct Costs",
        TotalCosts: null
      },
      ActualsData: {
        Type: "Total Direct Costs",
        TotalCosts: null
      }
    });
  // result.push({
  //   Type: "Change to Reference",
  //   TotalDirectCosts: null
  // });
  return result;
};
// used to format the cell in germman currency format;
function CurrencyCellRenderer(params: any) {
  return params.value == undefined ? null : new Intl.NumberFormat(countryCode).format(Number(parseFloat(params.value).toFixed(0)));
}

